import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  advancedSection,
  COMMON_FIELD_CONFIGS,
  LOOKUP_LIST_ID_FIELD,
  OPTIONS_EDITOR_FIELD,
  OPTIONS_SOURCE_TOGGLE_FIELD,
} from './field-config-shared';

/**
 * dropdown: type → label → placeholder → required → options → [Advanced: width, prefillLastValue]
 *
 * Single-select only (no allowMultiple — use select or checkbox-group for that).
 * The placeholder is shown in the trigger button when no option is selected.
 * Labels are user-generated content and are NOT translated.
 */
export function getDropdownFieldConfigFields(): FormlyFieldConfig[] {
  return [
    COMMON_FIELD_CONFIGS['type'],
    COMMON_FIELD_CONFIGS['label'],
    COMMON_FIELD_CONFIGS['placeholder'],
    COMMON_FIELD_CONFIGS['required'],
    OPTIONS_SOURCE_TOGGLE_FIELD,
    LOOKUP_LIST_ID_FIELD,
    OPTIONS_EDITOR_FIELD,
    advancedSection(COMMON_FIELD_CONFIGS['width'], COMMON_FIELD_CONFIGS['prefillLastValue']),
  ];
}
